export default __webpack_public_path__ + "static/media/img2.7d389b4c.png";